"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.email = void 0;
const Alignment_1 = require("../../enums/Alignment");
const game_center_asset_1 = require("../../utils/game-center-asset");
exports.email = {
    sender: 'info',
    topImage: (0, game_center_asset_1.getGameCenterAssetUrl)('mail-top.png'),
    bottomImage: (0, game_center_asset_1.getGameCenterAssetUrl)('mail-bottom.png'),
    headerTextStyle: {
        color: '000000',
        font: 'arial',
        fontSize: '24px',
        textAlign: Alignment_1.Alignment.CENTER,
    },
    bodyTextStyle: {
        color: '000000',
        font: 'arial',
        fontSize: '17px',
        textAlign: Alignment_1.Alignment.CENTER,
    },
    buttonStyle: {
        color: 'FFFFFF',
        font: 'arial',
        backgroundColor: '58BFEC',
        borderRadius: '0px',
    },
    verificationButtonText: 'Verify Account',
};
